import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";

import {
  constants,
  defaultPageSize,
} from "@entities/requisites/hooks/constants.ts";
import { requisitesApi } from "@shared/api";

export interface UseRequisitesListParams {
  assetCode?: string;
  pageSize?: number;
  paymentSystemId?: string;
}

/* eslint-disable perfectionist/sort-objects */
export const requisitesListQueryOptions = ({
  pageSize = defaultPageSize,
  assetCode,
  paymentSystemId,
}: UseRequisitesListParams) =>
  infiniteQueryOptions({
    queryKey: constants.list(pageSize, assetCode),
    queryFn: ({ pageParam }) =>
      requisitesApi.getApiV1BankAccounts({
        page: pageParam,
        pageSize,
        assetCode,
        paymentSystemId,
      }),
    placeholderData: keepPreviousData,
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      const { pagination } = lastPage.data;
      if (pagination.page >= pagination.pageCount - 1) {
        return undefined;
      }
      return pagination.page + 1;
    },
    select: (data) => {
      const flatList = data.pages.flatMap((page) => page.data.data);

      const lastPage = data.pages[data.pages.length - 1];

      return {
        list: flatList,
        pagination: lastPage.data.pagination,
        sort: lastPage.data.sort,
      };
    },
  });
